import { SvgStar, SvgX } from "assets";
import { black, gray6, mainColor } from "assets/styleUtils";
import { Header } from "components";
import { DotText } from "components/DotText";
import { ICompanyReview } from "data/company";
import useModal from "hooks/useModal";
import _ from "lodash";
import { uniqueId } from "lodash";
import { InfoModal } from "modal/InfoModal";
import { checkPopupClose, closePopup } from "pages/WeddingHall/WeddingHall";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "recoil/atoms";
import { headerState } from "recoil/header";
import { post } from "utils/ApiUtil";
import styles from "./style.module.css";

interface IImage {
  id: string;
  uri?: string;
  no?: number;
}

export default function UploadCompanyReviewPage() {
  const user = useRecoilValue(userState);
  const { state } = useLocation();
  const navigate = useNavigate();
  const { visibleModal, removeModal } = useModal();

  const { contructor_no, review_data } = state;
  const contentCount = 20;

  const [visitDay, setVisitDay] = useState("");
  const [contractDay, setContractDay] = useState("");
  const [content, setContent] = useState("");
  const [files, setFiles] = useState<File[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isCompleteContent, setIsCompleteContent] = useState<boolean>(false);
  const [images, setImages] = useState<IImage[]>([]);
  const [updateData, setUpdateData] = useState<ICompanyReview>();
  const [rating, setRating] = useState(1);
  const setHeader = useSetRecoilState(headerState);

  setHeader({
    isVisible: true,
    title: "리뷰 올리기",
    cloaseModal: () => removeModal("INFO_MODAL"),
    url: `-1`,
    right: {
      onClick: () => {
        !isLoading &&
          (isCompleteContent
            ? updateData
              ? throttleUpdate()
              : throttleCreate()
            : toast.error(`내용은 ${contentCount}자 보다 많아야 합니다`));
      },
      text: updateData ? "리뷰 수정" : "리뷰 올리기",
      color: isCompleteContent && !isLoading ? mainColor : gray6,
    },
  });

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const imageDelete = (id: string) => {
    setImages((prev) => {
      return prev.filter((prevItem) => prevItem.id !== id);
    });
  };

  const onUploadImage = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        const fileArray = Array.from(e.target.files);
        setFiles(fileArray);
      }
    },
    []
  );

  const uploadImage = async () => {
    if (files.length > 0) {
      try {
        const responses = await Promise.all(
          files.map(async (file) => {
            const formData = new FormData();
            formData.append("files", file);

            const response = await post("/api/utils/reviewimgs", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
            return {
              id: uniqueId(),
              uri: response.data.imglist,
            };
          })
        );
        setImages((prev) => {
          if (prev.length < 10) {
            const remainingSlots = 10 - prev.length;
            const newItems = responses.slice(0, remainingSlots);
            return [...prev, ...newItems];
          } else {
            toast.error("이미지는 10장 이하로 첨부해주세요");
            return prev;
          }
        });
      } catch (error) {
        console.error("Upload error", error);
        toast.error("업로드 오류가 발생했습니다");
      }
    }
  };

  const closePopupToday = () => {
    closePopup(1);
    removeModal("INFO_MODAL");
  };

  const create = async () => {
    if (!!isLoading) {
      return;
    }
    setIsLoading(true);
    setIsCompleteContent(false);
    try {
      const res = await post("/api/contructor/createReview", {
        contructor_no,
        title: "",
        content,
        rating,
        photolist: images
          .filter(({ uri }) => uri && uri.length > 3)
          .map(({ uri }) => ({ img_url: uri! })),
        contract_day: contractDay,
        visit_day: visitDay,
      });
      toast.success(res.message);
      if (res.success) {
        setTimeout(() => {
          setIsLoading(false);
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : "에러가 발생했습니다. 관리자에게 문의해주세요."
      );
      setIsLoading(false);
    }
  };
  const throttleCreate = _.throttle(create, 1000);

  const update = async () => {
    setIsLoading(true);
    if (!updateData) {
      return;
    }
    if (user?.status === 2) {
      return toast.error("관리자에 의해 활동이 정지되었습니다.");
    }

    try {
      const res = await post("/api/contructor/updateReview", {
        type: "modify",
        contructor_no,
        no: updateData.no,
        title: "",
        content,
        rating,
        photolist: images
          .filter(({ uri }) => uri && uri.length > 3)
          .map(({ uri, no }) => ({ img_url: uri!, no: no })),
        contract_day: contractDay,
        visit_day: visitDay,
      });
      toast.success(res.message);
      if (res.success) {
        setTimeout(() => {
          setIsLoading(false);
          navigate(-1);
        }, 2000);
      }
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : "에러가 발생했습니다. 관리자에게 문의해주세요."
      );
      setIsLoading(false);
    }
  };
  const throttleUpdate = _.throttle(update, 1000);

  useEffect(() => {
    setIsCompleteContent(content.length > contentCount);
  }, [content]);

  useEffect(() => {
    if (files) {
      uploadImage();
    }
  }, [files]);

  useEffect(() => {
    if (review_data) {
      setUpdateData(review_data);
      setContent(review_data.content);
      setContractDay(review_data.contract_day || "");
      setVisitDay(review_data.visit_day || "");
      setRating(review_data.rating);
      if (review_data.photo) {
        setImages(
          review_data.photo.map(
            ({ no, img_url }: { no: number; img_url: string }) => ({
              no,
              id: uniqueId(),
              uri: img_url,
            })
          )
        );
      }
    }
  }, [review_data]);

  useEffect(() => {
    checkPopupClose() ? null : openAnnouncement();
  }, []);

  function openAnnouncement() {
    visibleModal({
      id: "INFO_MODAL",
      edge: "center",
      modalchildren: (
        <InfoModal
          close={() => removeModal("INFO_MODAL")}
          closePopupToday={closePopupToday}
          content={
            <>
              <DotText
                numbering="1."
                text="100자 이하의 무성의 글은 삭제되며, 삭제 될 시 기지급된 포인트는 회수되며 활동정지 처리가 될 수 있습니다."
              />
              <DotText
                numbering="2."
                text="글 작성 시 500P가 적립됩니다. (일 단위 최대 1회가능)"
              />
              <DotText
                numbering="3."
                text="커뮤니티 게시글은 관리자의 검수를 거쳐 아래와 같은 사유에 부합 될 경우 삭제 될 수 있으며 삭제 될 시 기지급된 포인트는 회수됩니다. 또한, 3-1번에 해당하는 경우 무기한 활동 정지 처리 및 기지급된 포인트가 전체 회수 되는 점 안내드립니다. "
              />
              <DotText
                numbering="1"
                circleNumber={true}
                text="특정업체 또는 개인의 영리적 목적을 위한 글"
              />
              <DotText text="업체의 홍보활동 및 비방 목적으로 판명 또는 의심되는 글" />
              <DotText
                text="특정 업체에 대하여 특정 글 게시 조건으로 대가(예: 금전적
              보상, 상품 할인, 무료 제품 제공 등)를 제공받고 이를 밝히지
              않는 등 표시광고법령을 위반하는 게시글"
              />
              <DotText text="무분별한 포인트 적립을 위해 동일한 주제 반복/도배/스팸/무성의성 글 등 작성하는 경우" />
              <DotText
                numbering="2"
                circleNumber={true}
                text="부적합한 정보 게시"
              />
              <DotText text="허위 또는 과장된 글 게시" />
              <DotText text="직접 촬영하지 않은 사진 및 직접 경험하지 않은 글" />
              <DotText text="업체에 대한 근거 없는 일방적인 비방, 욕설 등이 담긴 후기" />
              <DotText text="글자수를 채우기 위한 특정 문자 혹은 내용 반복" />
              <DotText text="무관하거나 성의 없는 내용 (3줄 이하, 20자 이하)" />
              <DotText
                numbering="3"
                circleNumber={true}
                text="타인의 권리 등을 침해할 수 있는 내용게시"
              />
              <DotText
                text="타인의 개인정보나 사생활을 공개하는 내용 게시(예: 타인의
              전화번호, 이메일 주소, 우편 주소 등)"
              />
              <DotText
                text="정당한 권한 없이 타인의 지식재산권, 기타 소유권, 명예, 신용
            등을 침해하는 내용 게시"
              />
              <DotText
                numbering="4"
                circleNumber={true}
                text="불쾌함 등을 유발하거나 반사회적인 내용 게시"
              />
              <DotText
                text="욕설, 폭언, 비방 등 타인에게 불쾌하거나 위협이 되는 내용
            게시"
              />
              <DotText text="불법물, 음란물 또는 청소년 유해 매체물 게시" />
              <DotText
                text="범죄행위나 불법적인 행동을 전시 또는 조장하는 내용 게시 (예:
              폭력, 불법 약물 사용, 미성년자 음주, 아동 또는 동물 학대
              포함)"
              />
              <DotText
                numbering="5"
                circleNumber={true}
                text="기타 관련법령 및 이용약관, 운영정책에 위배되는 경우"
              />
              <DotText
                text="정보통신기기의 오작동을 일으킬 수 있는 악성코드나 데이터를
              포함한 내용 게시(예: 피싱, 멀웨어 사이트 링크 등)"
              />
              <DotText text="사기성 상품, 서비스, 사업 계획 등을 판촉하는 내용 게시" />
              <DotText
                numbering="6"
                circleNumber={true}
                text="기타 관련법령 및 이용약관, 운영정책에 위배되는 경우"
              />
            </>
          }
        />
      ),
    });
  }

  return (
    <>
      <div style={{ padding: "20px 25px" }}>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              lineHeight: "20px",
              margin: "10px 0",
            }}
          >
            <div style={{ color: black, fontWeight: "500", fontSize: "15px" }}>
              방문일자
            </div>
            <input
              type="date"
              value={visitDay}
              className={styles.customDate}
              onChange={(e) => setVisitDay(e.target.value)}
            />
          </div>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: gray6,
            }}
          />
        </div>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              lineHeight: "20px",
              margin: "10px 0",
            }}
          >
            <div style={{ color: black, fontWeight: "500", fontSize: "15px" }}>
              계약일자
            </div>
            <input
              type="date"
              value={contractDay}
              onChange={(e) => setContractDay(e.target.value)}
              className={styles.customDate}
            />
          </div>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: gray6,
              marginTop: "10px",
            }}
          />
        </div>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              lineHeight: "20px",
              margin: "10px 0",
            }}
          >
            <div style={{ color: black, fontWeight: "500", fontSize: "15px" }}>
              별점
            </div>
            <div style={{ display: "flex" }}>
              {[1, 2, 3, 4, 5].map((value) => {
                const isSelect = value <= rating;
                return (
                  <div key={value} onClick={() => setRating(value)}>
                    <SvgStar
                      fill={isSelect ? mainColor : "#BDBDBD"}
                      width={"25px"}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              height: "2px",
              backgroundColor: gray6,
              marginTop: "10px",
            }}
          />
        </div>
        <div>
          <textarea
            className={styles.textarea}
            rows={5}
            placeholder="업체에 대한 리뷰를 적어주세요"
            value={content}
            onChange={(e) => {
              setContent(e.target.value);
            }}
          />
        </div>

        <div
          style={{
            position: "absolute",
            bottom: 0,
            width: "90%",
            marginBottom: "10px",
          }}
        >
          <div
            style={{
              marginBottom: "10px",
              display: "flex",
              overflowX: images.length > 2 ? "scroll" : "hidden",
            }}
          >
            {(images || []).length > 0 &&
              images.map((img, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <div
                    style={{
                      width: "18px",
                      height: "18px",
                      borderRadius: "5px",
                      backgroundColor: gray6,
                      position: "absolute",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      top: "0px",
                      right: "10px",
                    }}
                    onClick={() => imageDelete(img.id)}
                  >
                    <SvgX width={15} height={15} />
                  </div>
                  <img
                    src={img.uri}
                    style={{
                      width: "100px",
                      height: "100px",
                      marginRight: "10px",
                    }}
                  />{" "}
                </div>
              ))}
          </div>
          <div
            style={{
              height: "2px",
              backgroundColor: gray6,
              marginBottom: "10px",
            }}
          />
          <div style={{ display: "flex" }}>
            <img
              src={"/images/photomain.png"}
              alt="Upload Photo"
              style={{ cursor: "pointer" }}
              onClick={handleClick}
            />

            <input
              ref={fileInputRef}
              type="file"
              name="image"
              accept=".jpg, .png, .jpeg, .gif, image/jpg, image/png, image/jpeg, image/gif"
              onChange={onUploadImage}
              multiple
              style={{ display: "none", direction: "rtl" }}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "10px",
              }}
            >
              {images.length > 0 ? images.length : 0}/10
            </div>
          </div>
        </div>
        <ToastContainer
          position="bottom-center"
          limit={1}
          closeButton={false}
          autoClose={1000}
          theme="light"
        />
      </div>
    </>
  );
}
